/* ABC Automobiles · comportements du thème */
(function () {
  "use strict";
  document.documentElement.classList.add("js-ok");
  var ABC = window.ABC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- iPhone avec Safari 26 et plus : sa barre flotte par-dessus la page et la page s'arrête ~15 px au-dessus d'elle
     (mesuré le 04.10.2026 sur iPhone 440×956, Safari 27 : 17 px barre ouverte, 12 px réduite). Notre barre descend dans cette marge.
     Pas pour l'écran d'accueil (zone sûre ≠ 0), Chrome, Firefox, Edge ou les navigateurs intégrés aux applis. ---------- */
  (function () {
    var ua = navigator.userAgent, v = ua.match(/Version\/(\d+)/);
    if (!/iPhone/.test(ua) || !v || +v[1] < 26 || !/Safari\//.test(ua) || /CriOS|FxiOS|EdgiOS|OPiOS|GSA\//.test(ua)) return;
    if (navigator.standalone || (window.matchMedia && matchMedia("(display-mode: standalone)").matches)) return;
    var t = document.createElement("div");
    t.style.cssText = "position:fixed;left:0;top:0;width:1px;visibility:hidden;pointer-events:none;height:env(safe-area-inset-bottom)";
    document.documentElement.appendChild(t);
    var zone = t.getBoundingClientRect().height; t.parentNode.removeChild(t);
    if (zone === 0) document.documentElement.classList.add("safari-flottant");
  })();

  /* ---------- Toast ---------- */
  var minuteur;
  function toast(html, erreur) {
    var t = $("#toast"); if (!t) return;
    $("#toast-t").innerHTML = html;
    t.classList.toggle("erreur", !!erreur);
    t.querySelector("i").textContent = erreur ? "!" : "✓";
    t.classList.add("on");
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { t.classList.remove("on"); }, 4200);
  }
  function echapper(s) { var d = document.createElement("div"); d.textContent = s; return d.innerHTML; }

  /* ---------- Apparition au défilement ---------- */
  function reveler() {
    var els = $$(".revele:not(.vu)");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("vu"); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("vu"); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Horaires : ouvert / fermé à l'heure suisse ---------- */
  var JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
  function maintenantSuisse() {
    try {
      var parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Zurich", weekday: "short", hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      var j = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].indexOf(o.weekday);
      return { jour: j, min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    } catch (e) { var d = new Date(); return { jour: d.getDay(), min: d.getHours() * 60 + d.getMinutes() }; }
  }
  function plages(j) {
    var t = (ABC.horaires && ABC.horaires[j]) || "", res = [], re = /(\d{1,2})\s*(?:[:h.]\s*(\d{2})?)?\s*[-–]\s*(\d{1,2})\s*(?:[:h.]\s*(\d{2})?)?/g, m;
    while ((m = re.exec(t))) res.push([+m[1] * 60 + (+m[2] || 0), +m[3] * 60 + (+m[4] || 0)]);
    return res;
  }
  function surAppel(j) { return /appel|rendez/i.test((ABC.horaires && ABC.horaires[j]) || ""); }
  function hhmm(m) { var h = Math.floor(m / 60), mi = m % 60; return h + "h" + (mi < 10 ? "0" : "") + mi; }
  function etatOuverture() {
    var n = maintenantSuisse(), p = plages(n.jour), i, k;
    for (i = 0; i < p.length; i++) if (n.min >= p[i][0] && n.min < p[i][1]) return surAppel(n.jour) ? { ouvert: false, appel: true, texte: "Sur appel jusqu'à " + hhmm(p[i][1]) } : { ouvert: true, texte: "Ouvert jusqu'à " + hhmm(p[i][1]) };
    for (k = 0; k < 8; k++) {
      var jj = (n.jour + k) % 7, pp = surAppel(jj) ? [] : plages(jj);
      for (i = 0; i < pp.length; i++) if (k > 0 || pp[i][0] > n.min)
        return { ouvert: false, texte: "Fermé · ouvre " + (k === 0 ? "à " : k === 1 ? "demain à " : JOURS[jj] + " à ") + hhmm(pp[i][0]) };
    }
    return null;
  }
  function horaires() {
    var e = etatOuverture(), auj = maintenantSuisse().jour;
    $$("[data-statut]").forEach(function (s) { if (e) { s.classList.remove("ouvert", "ferme", "appel"); s.classList.add(e.ouvert ? "ouvert" : e.appel ? "appel" : "ferme"); s.title = e.texte; var c = s.querySelector("[data-statut-texte]"); if (c) c.textContent = e.texte + " · "; } });
    $$("[data-puce-statut]").forEach(function (s) { if (e) { s.classList.toggle("ferme", !e.ouvert && !e.appel); s.classList.toggle("appel", !!e.appel); s.classList.toggle("ouvert", e.ouvert); s.querySelector("[data-etat]").textContent = e.texte; } });
    $$("[data-horaires] [data-jour]").forEach(function (d) { d.classList.toggle("auj", +d.getAttribute("data-jour") === auj); });
  }

  /* ---------- Panier : ajout sans quitter la page ---------- */
  function majCompte(n) {
    $$("[data-compte-panier]").forEach(function (p) {
      p.textContent = n;
      if (n > 0) p.removeAttribute("data-vide"); else p.setAttribute("data-vide", "");
      p.classList.add("saute"); setTimeout(function () { p.classList.remove("saute"); }, 300);
    });
  }
  document.addEventListener("submit", function (ev) {
    var f = ev.target;
    if (!f.hasAttribute || !f.hasAttribute("data-ajout") || !window.fetch) return;
    ev.preventDefault();
    if (f.hasAttribute("data-envoi")) return;
    f.setAttribute("data-envoi", "");
    var bouton = f.querySelector("[type=submit]");
    if (bouton) { bouton.disabled = true; bouton.setAttribute("aria-busy", "true"); }
    var fin = function () { f.removeAttribute("data-envoi"); if (bouton) { bouton.disabled = false; bouton.removeAttribute("aria-busy"); } };
    fetch((ABC.ajout || "/cart/add") + ".js", { method: "POST", headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: new FormData(f) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : "Impossible d'ajouter cet article pour le moment. Réessayez ou écrivez-nous sur WhatsApp.");
        var nom = res.j.product_title || (res.j.items && res.j.items[0] && res.j.items[0].product_title) || "Article";
        toast(echapper(nom) + " ajouté au panier.<a href=\"" + (ABC.panier || "/cart") + "\">Voir le panier</a>");
        return fetch((ABC.panier || "/cart") + ".js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { majCompte(c.item_count); }).catch(function () {});
      })
      .catch(function (e) {
        var m = e && e.message && !/Failed to fetch|NetworkError|Unexpected token|JSON/i.test(e.message) ? e.message : "Connexion impossible. Vérifiez votre réseau et réessayez.";
        toast(echapper(m), true);
      })
      .then(fin, fin);
  });

  /* ---------- Quantités +/- ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-plus],[data-moins]");
    if (!b) return;
    var box = b.closest("[data-qte]"), inp = box && box.querySelector("input");
    if (!inp) return;
    var min = inp.hasAttribute("min") ? +inp.min : 0, max = inp.hasAttribute("max") ? +inp.max : Infinity;
    var v = (+inp.value || 0) + (b.hasAttribute("data-plus") ? 1 : -1);
    inp.value = Math.max(min, Math.min(max, v));
    inp.dispatchEvent(new Event("change", { bubbles: true }));
  });
  var minuteursMaj = [];
  function annulerMaj() { minuteursMaj.forEach(clearTimeout); minuteursMaj = []; }
  document.addEventListener("click", function (ev) { if (ev.target.closest && ev.target.closest("[name=checkout],.retirer")) annulerMaj(); }, true);
  document.addEventListener("change", function (ev) {
    var i = ev.target;
    if (i.hasAttribute && i.hasAttribute("data-auto-maj")) {
      clearTimeout(i._t);
      minuteursMaj.push(i._t = setTimeout(function () { var f = i.form; if (f) { var h = document.createElement("input"); h.type = "hidden"; h.name = "update"; h.value = "1"; f.appendChild(h); f.submit(); } }, 700));
    }
    if (i.hasAttribute && i.hasAttribute("data-tri")) {
      var u = new URL(location.href); u.searchParams.set("sort_by", i.value); u.searchParams.delete("page"); location.href = u.toString();
    }
  });

  /* ---------- Demande de pneus : les lignes de la demande (WhatsApp et copie dans l'app) ---------- */
  function lignesPneus(f) {
    var val = function (sel) { var e = f.querySelector(sel); return e ? e.value.trim() : ""; };
    var inc = f.querySelector("[data-d-dim-inconnue]"), s = f.querySelector("[data-d-saison]:checked");
    var dim = inc && inc.checked ? "à trouver avec ma voiture" : val("[data-d-larg]") + "/" + val("[data-d-haut]") + " R" + val("[data-d-diam]");
    var gamme = val("[data-d-gamme]"), marque = val("[data-d-marque]").slice(0, 60);
    return ["Dimension : " + dim, "Saison : " + (s ? s.value : ""), "Nombre : " + val("[data-d-qte]"),
      gamme && gamme !== "Peu importe" ? "Gamme : " + gamme : "", marque ? "Marque préférée : " + marque : "", "Montage : " + val("[data-d-montage]")].filter(Boolean);
  }
  // « Je ne connais pas ma dimension » : les trois listes ne sont plus obligatoires (et ne partent pas).
  document.addEventListener("change", function (ev) {
    var c = ev.target.closest && ev.target.closest("[data-d-dim-inconnue]");
    if (!c) return;
    ["[data-d-larg]", "[data-d-haut]", "[data-d-diam]"].forEach(function (s) { var e = c.form && c.form.querySelector(s); if (e) { e.required = !c.checked; e.disabled = c.checked; } });
  });

  /* ---------- Demande de devis : envoi par WhatsApp avec les champs du formulaire ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-devis-wa]");
    if (!b) return;
    var f = b.closest("form"); if (!f) return;
    var val = function (sel) { var e = f.querySelector(sel); return e ? e.value.trim() : ""; };
    var piece = b.hasAttribute("data-wa-piece"), reprise = b.hasAttribute("data-wa-reprise"), pneus = b.hasAttribute("data-wa-pneus");
    if (pneus) {
      // La dimension (sauf « je ne la connais pas ») et la saison, avant le reste.
      var inc = f.querySelector("[data-d-dim-inconnue]");
      var dims = (inc && inc.checked ? [] : ["[data-d-larg]", "[data-d-haut]", "[data-d-diam]"]).map(function (s) { return f.querySelector(s); });
      for (var k = 0; k < dims.length; k++) { if (dims[k] && !dims[k].value) { dims[k].focus(); if (dims[k].reportValidity) dims[k].reportValidity(); return; } }
      if (!f.querySelector("[data-d-saison]:checked")) { var s0 = f.querySelector("[data-d-saison]"); if (s0) { s0.focus(); if (s0.reportValidity) s0.reportValidity(); } return; }
    }
    var obligatoires = (piece ? ["[data-d-piece]", "[data-d-veh]", "[data-d-nom]"] : reprise ? ["[data-d-veh]", "[data-d-an]", "[data-d-km]", "[data-d-nom]"] : pneus ? ["[data-d-veh]", "[data-d-nom]"] : ["[data-d-veh]", "[data-d-msg]", "[data-d-nom]"]).concat(["[data-d-rue]", "[data-d-npa]", "[data-d-loc]"]).map(function (s) { return f.querySelector(s); });
    for (var i = 0; i < obligatoires.length; i++) {
      var e = obligatoires[i];
      if (e && !e.value.trim()) { e.focus(); if (e.reportValidity) e.reportValidity(); return; }
    }
    var an = val("[data-d-an]"), c24 = val("[data-d-c24]"), ch = val("[data-d-ch]"), ref = val("[data-d-ref]"), msg = val("[data-d-msg]");
    var pro = f.getAttribute("data-client-pro") || "";
    var meme = f.querySelector("[data-d-meme]"), adresse = (pro ? "\nClient pro : " + pro : "") + "\nAdresse : " + val("[data-d-rue]") + ", " + val("[data-d-npa]") + " " + val("[data-d-loc]") + (meme && meme.checked ? " (comme sur le permis de circulation)" : "");
    var vehicule = "\nVéhicule : " + val("[data-d-veh]") + (an ? " (" + an + ")" : "") + (c24 ? "\nCase 24 : " + c24 : "") + (ch ? "\nChâssis : " + ch : "");
    var km = val("[data-d-km]"), exp = val("[data-d-exp]"), prix = val("[data-d-prix]");
    var texte = reprise
      ? "Bonjour, je souhaite vendre ma voiture." + vehicule + "\nKilométrage : " + km + (exp ? "\nDernière expertise : " + exp : "") + (prix ? "\nPrix souhaité : CHF " + prix : "") + (msg ? "\nÉtat et remarques : " + msg : "") + "\nNom : " + val("[data-d-nom]") + adresse + "\nJe vous envoie des photos de la voiture."
      : piece
      ? "Bonjour, je cherche une pièce.\nPièce : " + val("[data-d-piece]") + (ref ? "\nRéférence : " + ref : "") + vehicule + (msg ? "\nPrécisions : " + msg : "") + "\nNom : " + val("[data-d-nom]") + adresse
      : pneus
      ? "Bonjour, je cherche des pneus.\n" + lignesPneus(f).join("\n") + vehicule + (msg ? "\nPrécisions : " + msg : "") + "\nNom : " + val("[data-d-nom]") + adresse
      : "Bonjour, je souhaite un devis.\nPrestation : " + val("[data-d-presta]") + vehicule + "\nDemande : " + msg + "\nNom : " + val("[data-d-nom]") + adresse;
    window.open("https://wa.me/" + (ABC.wa || "") + "?text=" + encodeURIComponent(texte), "_blank", "noopener");
  });
  /* ---------- Demande de compte pro : envoi par WhatsApp (l'e-mail sert à se connecter ensuite) ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-pro-wa]");
    if (!b) return;
    var f = b.closest("form"); if (!f) return;
    var val = function (sel) { var e = f.querySelector(sel); return e ? e.value.trim() : ""; };
    var champs = ["[data-p-ent]", "[data-p-nom]", "[data-p-mail]", "[data-p-rue]", "[data-p-npa]", "[data-p-loc]"].map(function (s) { return f.querySelector(s); });
    for (var i = 0; i < champs.length; i++) {
      var e = champs[i];
      if (e && (!e.value.trim() || (e.checkValidity && !e.checkValidity()))) { e.focus(); if (e.reportValidity) e.reportValidity(); return; }
    }
    var t = f.querySelector("[data-p-type]:checked"), ide = val("[data-p-ide]"), msg = val("[data-p-msg]");
    var texte = "Bonjour, je souhaite un compte pro sur votre site.\nType : " + (t ? t.value : "") + "\nEntreprise : " + val("[data-p-ent]") + (ide ? "\nIDE : " + ide : "") +
      "\nNom : " + val("[data-p-nom]") + "\nAdresse : " + val("[data-p-rue]") + ", " + val("[data-p-npa]") + " " + val("[data-p-loc]") +
      "\nE-mail pour me connecter : " + val("[data-p-mail]") + (msg ? "\nMessage : " + msg : "");
    copieComptePro(f);
    window.open("https://wa.me/" + (ABC.wa || "") + "?text=" + encodeURIComponent(texte), "_blank", "noopener");
  });
  /* ---------- Demande de compte pro : copie dans l'app ABC Garage (API du garage) ----------
     Avec l'e-mail (formulaire) comme avec WhatsApp : Bekim la reçoit dans l'app, avec une notification, et accepte le
     compte d'un appui. Une seule copie par 10 minutes ; si l'API ne répond pas, l'e-mail ou WhatsApp suffisent. */
  function copieComptePro(f) {
    if (!ABC.api || !window.fetch || (f._copie && Date.now() - f._copie < 600000)) return;
    f._copie = Date.now();
    var val = function (sel, max) { var e = f.querySelector(sel); return e ? e.value.trim().slice(0, max || 160) : ""; };
    var t = f.querySelector("[data-p-type]:checked");
    var corps = JSON.stringify({
      type: t && t.value === "Professionnel" ? "professionnel" : "garagiste",
      entreprise: val("[data-p-ent]", 120), ide: val("[data-p-ide]", 30), nom: val("[data-p-nom]", 120), telephone: val("#p-tel", 40),
      email: val("[data-p-mail]"), rue: val("[data-p-rue]"), npa: val("[data-p-npa]", 10), localite: val("[data-p-loc]", 80),
      message: val("[data-p-msg]", 1000), piege: val("[data-p-piege]")
    });
    var adresse = ABC.api.replace(/\/+$/, "") + "/v1/public/comptes-pro";
    try {
      fetch(adresse, { method: "POST", mode: "cors", credentials: "omit", keepalive: true, headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: corps }).catch(function () {});
    } catch (e) {
      try { if (navigator.sendBeacon) navigator.sendBeacon(adresse, new Blob([corps], { type: "text/plain;charset=UTF-8" })); } catch (e2) {}
    }
  }
  document.addEventListener("submit", function (ev) { var f = ev.target; if (f.matches && f.matches("#form-pro")) copieComptePro(f); });
  /* ---------- Demande de devis : copie dans l'app ABC Garage (API du garage) ----------
     L'e-mail part comme avant : rien n'est bloqué ni retardé. En plus, la demande arrive dans l'app
     de Bekim. Requête « simple » (texte), gardée en vie pendant le changement de page ; si l'API ne
     répond pas, l'e-mail suffit et le client ne voit rien. */
  document.addEventListener("submit", function (ev) {
    var f = ev.target;
    if (!ABC.api || !f.matches || !f.matches("#form-devis") || !window.fetch) return;
    if (f._copie && Date.now() - f._copie < 600000) return;   // renvoi après la vérification anti-robot (hCaptcha de Shopify) : une seule copie
    f._copie = Date.now();
    var val = function (sel, max) { var e = f.querySelector(sel); return e ? e.value.trim().slice(0, max || 160) : ""; };
    var piece = !!f.querySelector("[data-d-piece]"), reprise = !!f.querySelector("[data-d-km]"), pneus = !!f.querySelector("[data-d-pneus]");
    var lignes = piece ? ["Pièce : " + val("[data-d-piece]"), val("[data-d-ref]") && "Référence : " + val("[data-d-ref]")]
      : reprise ? ["Vente ou reprise de la voiture", val("[data-d-prix]") && "Prix souhaité : CHF " + val("[data-d-prix]"), val("[data-d-exp]") && "Dernière expertise : " + val("[data-d-exp]")]
      : pneus ? lignesPneus(f)
      : [];
    lignes.push(val("[data-d-msg]", 1500));
    if (f.getAttribute("data-client-pro")) lignes.unshift("Client pro : " + f.getAttribute("data-client-pro").slice(0, 120));
    var meme = f.querySelector("[data-d-meme]");
    if (meme && meme.checked) lignes.push("Nom et adresse comme sur le permis de circulation.");
    var corps = JSON.stringify({
      nom: val("[data-d-nom]", 120), telephone: val("#d-tel", 40), email: val("#d-mail"),
      rue: val("[data-d-rue]"), npa: val("[data-d-npa]", 10), localite: val("[data-d-loc]", 80),
      prestation: piece ? "Pièce sur commande" : reprise ? "Vente ou reprise" : pneus ? "Pneus et équilibrage" : val("[data-d-presta]", 80),
      marqueModele: val("[data-d-veh]", 120), annee: val("[data-d-an]", 10), case24: val("[data-d-c24]", 40),
      chassis: val("[data-d-ch]", 40), kilometrage: val("[data-d-km]", 12),
      message: lignes.filter(Boolean).join("\n").slice(0, 2000), piege: val("[data-d-piege]")
    });
    var adresse = ABC.api.replace(/\/+$/, "") + "/v1/public/demandes";
    try {
      fetch(adresse, { method: "POST", mode: "cors", credentials: "omit", keepalive: true, headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: corps }).catch(function () {});
    } catch (e) {
      try { if (navigator.sendBeacon) navigator.sendBeacon(adresse, new Blob([corps], { type: "text/plain;charset=UTF-8" })); } catch (e2) {}
    }
  });
  (function () {
    var p = new URLSearchParams(location.search).get("piece"), champ = document.querySelector("[data-d-piece]");
    if (p && champ && !champ.value) champ.value = p.slice(0, 120);
  })();
  if (/[?&]contact_posted=true/.test(location.search) && document.getElementById("demande-piece")) {
    setTimeout(function () { document.getElementById("demande-piece").scrollIntoView({ block: "start" }); }, 50);
  }
  ["offre", "question-v", "demande-pro", "demande-pneus"].forEach(function (id) {
    if (/[?&]contact_posted=true/.test(location.search) && document.getElementById(id) && document.getElementById(id).querySelector(".message-ok, .message-err")) setTimeout(function () { document.getElementById(id).scrollIntoView({ block: "start" }); }, 50);
  });
  if (/[?&]contact_posted=true/.test(location.search) && document.getElementById("devis")) {
    setTimeout(function () { document.getElementById("devis").scrollIntoView({ block: "start" }); }, 50);
  }

  /* ---------- Photo du permis de circulation : lecture sur l'appareil (assets/permis-lecture.js) ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-permis-btn]");
    if (!b) return;
    var i = b.closest("form") && b.closest("form").querySelector("[data-permis]");
    if (i) i.click();
  });
  document.addEventListener("change", function (ev) {
    var i = ev.target;
    if (!i.hasAttribute || !i.hasAttribute("data-permis") || !i.files || !i.files[0]) return;
    var f = i.closest("form"), etat = f.querySelector("[data-permis-etat]"), b = f.querySelector("[data-permis-btn]");
    var dire = function (t) { etat.hidden = false; etat.textContent = t; };
    if (!window.ABCPermis) { dire("La lecture n'est pas disponible sur cet appareil : remplissez à la main."); return; }
    b.disabled = true;
    f.querySelectorAll(".rempli,.a-completer").forEach(function (e) { e.classList.remove("rempli", "a-completer"); });
    dire("Lecture du permis de circulation… La première fois, le chargement prend quelques secondes.");
    window.ABCPermis.lire(i.files[0], function (p, etape) { dire("Lecture du permis de circulation" + (etape > 1 ? ", deuxième passage" : "") + "… " + Math.round(p * 100) + " %"); }).then(function (r) {
      var lus = [], manquants = [], meme = f.querySelector("[data-d-meme]");
      f.__permis = r;
      var mettre = function (sel, v, nom) {
        var e = f.querySelector(sel); if (!e) return;
        if (v) { e.value = v; e.classList.add("rempli"); lus.push(nom); } else if (!e.value) { e.classList.add("a-completer"); manquants.push(nom); }
      };
      mettre("[data-d-veh]", r.marqueType, "marque et type");
      mettre("[data-d-an]", r.annee, "année");
      mettre("[data-d-c24]", r.case24, "case 24");
      mettre("[data-d-ch]", r.chassis, "châssis");
      if (meme && meme.checked) {
        if (r.titulaire) { remplirTitulaire(f, r.titulaire); lus.push("nom et adresse"); }
        else manquants.push("nom et adresse (la page de gauche du permis doit être sur la photo)");
        etatMeme(f);
      }
      if (!lus.length) dire("Rien n'a pu être lu sur cette photo. Reprenez le permis de circulation ouvert, à plat et sans reflet, ou remplissez à la main.");
      else dire("✓ Rempli : " + lus.join(", ") + "." + (manquants.length ? " ✗ Pas lu : " + manquants.join(", ") + ". Tapez-les, ou reprenez la photo de plus près." : " Vérifiez d'un coup d'œil.") + (r.titulaire && meme && !meme.checked ? " Le nom et l'adresse ont été lus : cochez « Mon nom et mon adresse sont ceux du permis de circulation » pour les reprendre." : ""));
    }, function () {
      dire("La lecture n'a pas marché. Remplissez à la main, ou envoyez la photo par WhatsApp.");
    }).then(function () { b.disabled = false; i.value = ""; });
  });

  document.addEventListener("input", function (ev) { if (ev.target.classList) ev.target.classList.remove("rempli", "a-completer"); });

  /* ---------- « Mon nom et mon adresse sont ceux du permis de circulation » : remplis d'après la photo ---------- */
  function remplirTitulaire(f, t) {
    [["[data-d-nom]", t.nom], ["[data-d-rue]", t.rue], ["[data-d-npa]", t.npa], ["[data-d-loc]", t.localite]].forEach(function (c) {
      var e = f.querySelector(c[0]); if (e && c[1]) { e.value = c[1]; e.classList.remove("a-completer"); e.classList.add("rempli"); }
    });
  }
  function etatMeme(f) {
    var c = f.querySelector("[data-d-meme]"), e = f.querySelector("[data-meme-etat]"), r = f.__permis;
    if (!c || !e) return;
    if (!c.checked) { e.hidden = true; return; }
    e.hidden = false;
    if (r && r.titulaire) e.innerHTML = "✓ Nom et adresse repris du permis de circulation. Vérifiez d'un coup d'œil.";
    else if (r) e.innerHTML = "Le nom et l'adresse n'ont pas pu être lus : la page de gauche du permis doit être sur la photo. <button type=\"button\" class=\"lien-photo\" data-permis-btn>Reprendre la photo</button>, ou tapez-les.";
    else e.innerHTML = "<button type=\"button\" class=\"lien-photo\" data-permis-btn>Prenez la photo du permis de circulation ouvert</button> : le nom et l'adresse se rempliront tout seuls.";
  }
  document.addEventListener("change", function (ev) {
    var c = ev.target;
    if (!c.hasAttribute || !c.hasAttribute("data-d-meme")) return;
    var f = c.closest("form");
    if (c.checked && f.__permis && f.__permis.titulaire) remplirTitulaire(f, f.__permis.titulaire);
    etatMeme(f);
  });

  /* ---------- Menu du téléphone ---------- */
  document.addEventListener("click", function (ev) {
    var d = document.getElementById("menu-mobile");
    if (!d || !d.showModal) return;
    var o = ev.target.closest && ev.target.closest("[data-ouvrir-menu]");
    if (o) { d.showModal(); o.setAttribute("aria-expanded", "true"); return; }
    if ((ev.target.closest && ev.target.closest("[data-fermer-menu]")) || ev.target === d) d.close();
  });
  document.addEventListener("close", function (ev) {
    if (ev.target.id !== "menu-mobile") return;
    $$("[data-ouvrir-menu]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }, true);

  /* ---------- Galerie produit ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-galerie] .vignettes-p button");
    if (!b) return;
    var g = b.closest("[data-galerie]"), img = g.querySelector(".grande img");
    if (img) { img.removeAttribute("srcset"); img.src = b.getAttribute("data-src"); }
    $$("button", b.parentNode).forEach(function (x) { x.setAttribute("aria-current", x === b ? "true" : "false"); });
  });

  /* ---------- Colonne des rayons : la flèche ouvre ou referme les sous-rayons ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-filtres-plus]");
    if (!b) return;
    var l = document.getElementById(b.getAttribute("aria-controls")), ouvrir = b.getAttribute("aria-expanded") !== "true";
    if (!l) return;
    l.hidden = !ouvrir; b.setAttribute("aria-expanded", ouvrir ? "true" : "false");
  });

  /* ---------- Sous-rayons : sur téléphone, 8 cases puis « Voir les N catégories » ---------- */
  function sousRayons() {
    $$("[data-sous-rayons]").forEach(function (n) {
      var b = $("[data-sr-plus]", n);
      if (!b || n.__ok) return; n.__ok = true;
      n.classList.add("replie"); b.hidden = false;
      b.addEventListener("click", function () {
        n.classList.remove("replie"); b.hidden = true;
        var a = $(".sr-grille > li:nth-child(9) a", n); // le bouton disparaît : on garde la place au clavier
        if (a) a.focus({ preventScroll: true });
      });
    });
    /* Page d'un sous-rayon : la rangée de puces montre la catégorie en cours */
    $$(".sr-puces").forEach(function (r) {
      var a = $("[aria-current]", r);
      if (a) r.scrollLeft = a.offsetLeft - (r.clientWidth - a.clientWidth) / 2;
    });
  }

  /* ---------- Galerie d'une voiture : flèches, glisser du doigt, plein écran ---------- */
  function galeriesVoiture() {
    $$("[data-galerie-v]").forEach(function (g) {
      if (g.__ok) return; g.__ok = true;
      var vign = $$("[data-gv-i]", g), img = $(".gv-ouvrir img", g), compte = $("[data-gv-compte]", g), dlg = $("[data-gv-plein]"), i = 0;
      if (!img) return;
      var montrer = function (n) {
        if (!vign.length) return;
        i = (n + vign.length) % vign.length;
        var b = vign[i];
        img.removeAttribute("srcset"); img.src = b.getAttribute("data-src"); img.alt = b.getAttribute("data-alt") || "";
        vign.forEach(function (v, k) { v.setAttribute("aria-current", k === i ? "true" : "false"); });
        var bande = b.parentNode; bande.scrollLeft = b.offsetLeft - (bande.clientWidth - b.clientWidth) / 2;
        if (compte) compte.textContent = (i + 1) + " / " + vign.length;
        if (dlg && dlg.open) plein();
      };
      var plein = function () {
        /* D'abord la photo déjà chargée (affichage immédiat), puis la version nette dès qu'elle est prête. */
        var p = $("[data-gv-plein-img]", dlg), b = vign[i];
        p.src = img.currentSrc || img.src; p.alt = img.alt;
        if (b) { var net = new Image(), cible = b; net.onload = function () { if (vign[i] === cible && dlg.open) p.src = net.src; }; net.src = b.getAttribute("data-plein"); }
        var c = $("[data-gv-compte-plein]", dlg); if (c && vign.length) c.textContent = (i + 1) + " / " + vign.length;
      };
      vign.forEach(function (b, k) { b.addEventListener("click", function () { montrer(k); }); });
      $$("[data-gv-prec]", g).forEach(function (b) { b.addEventListener("click", function () { montrer(i - 1); }); });
      $$("[data-gv-suiv]", g).forEach(function (b) { b.addEventListener("click", function () { montrer(i + 1); }); });
      var glisser = function (zone) {
        var x0 = null, y0 = null;
        zone.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        zone.addEventListener("touchend", function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) montrer(i + (dx < 0 ? 1 : -1));
        });
      };
      glisser($(".gv-grande", g));
      var ouvrir = $("[data-gv-ouvrir]", g);
      if (ouvrir && dlg && dlg.showModal) {
        ouvrir.addEventListener("click", function () { plein(); dlg.showModal(); });
        glisser(dlg);
        $$("[data-gv-prec]", dlg).forEach(function (b) { b.addEventListener("click", function () { montrer(i - 1); }); });
        $$("[data-gv-suiv]", dlg).forEach(function (b) { b.addEventListener("click", function () { montrer(i + 1); }); });
        $("[data-gv-fermer]", dlg).addEventListener("click", function () { dlg.close(); });
        dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") montrer(i + 1); else if (e.key === "ArrowLeft") montrer(i - 1); });
      }
    });
  }
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest && ev.target.closest("[data-partager]");
    if (!b) return;
    var d = { title: b.getAttribute("data-titre") || document.title, url: location.href.split(/[?#]/)[0] };
    if (navigator.share) { navigator.share(d).catch(function () {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(d.url).then(function () { toast("Lien copié : collez-le dans un message."); }, function () { toast("Copiez l'adresse de la page pour la partager.", true); });
  });

  /* ---------- Onglets du chercheur ---------- */
  document.addEventListener("click", function (ev) {
    var t = ev.target.closest("[data-onglets] [role=tab]");
    if (!t) return;
    var box = t.closest("[data-onglets]");
    $$("[role=tab]", box).forEach(function (x) {
      var on = x === t; x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1;
      var p = document.getElementById(x.getAttribute("aria-controls")); if (p) p.hidden = !on;
    });
  });
  document.addEventListener("keydown", function (ev) {
    var t = ev.target.closest && ev.target.closest("[data-onglets] [role=tab]");
    if (!t || (ev.key !== "ArrowRight" && ev.key !== "ArrowLeft")) return;
    var tabs = $$("[role=tab]", t.closest("[data-onglets]")), i = tabs.indexOf(t);
    var n = tabs[(i + (ev.key === "ArrowRight" ? 1 : tabs.length - 1)) % tabs.length]; n.focus(); n.click();
  });

  /* ---------- Recherche par véhicule → WhatsApp ---------- */
  function lienWa(msg) { return "https://wa.me/" + (ABC.wa || "") + "?text=" + encodeURIComponent(msg); }
  document.addEventListener("submit", function (ev) {
    var f = ev.target;
    if (!f.hasAttribute || !f.hasAttribute("data-vehicule-form")) return;
    ev.preventDefault();
    var m = f.marque.value || "marque ?", mo = f.modele.value || "modèle ?", a = f.annee.value || "année ?";
    window.open(lienWa("Bonjour, je cherche des pièces pour ma voiture : " + m + " " + mo + ", " + a + ". La pièce : "), "_blank", "noopener");
  });

  /* ---------- Explorateur de voiture ---------- */
  document.addEventListener("click", function (ev) {
    var b = ev.target.closest("[data-explorateur] [data-zone]");
    if (!b) return;
    var box = b.closest("[data-explorateur]"), id = b.getAttribute("data-zone");
    $$("[data-zone]", box).forEach(function (x) { x.setAttribute("aria-pressed", x.getAttribute("data-zone") === id ? "true" : "false"); });
    $$("[data-zone-contenu]", box).forEach(function (c) { c.hidden = c.getAttribute("data-zone-contenu") !== id; });
  });

  /* ---------- Rendez-vous atelier → WhatsApp ---------- */
  function joursRdv(box) {
    var cible = box.querySelector("[data-jours]"); if (!cible || cible.children.length) return;
    var noms = ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"], d = new Date(), n = 0, html = "", k = 0;
    while (k < 6 && n < 14) {
      n++; var x = new Date(d.getTime() + n * 864e5), j = x.getDay();
      if (plages(j).length === 0) continue;
      html += '<button type="button" class="jour" data-jour-rdv="' + x.toLocaleDateString("fr-CH", { weekday: "long", day: "numeric", month: "long" }) + '" aria-pressed="' + (k === 0 ? "true" : "false") + '">' + noms[j] + "<b>" + x.getDate() + "</b></button>";
      k++;
    }
    cible.innerHTML = html;
  }
  function majLienRdv(box) {
    var travaux = $$(".puce[aria-pressed=true]", box).map(function (p) { return p.textContent; }).join(", ") || "à préciser";
    var j = box.querySelector(".jour[aria-pressed=true]"), v = box.querySelector("[data-vehicule]").value || "véhicule à préciser";
    var msg = "Bonjour, je souhaite un rendez-vous à l'atelier. Travail : " + travaux + ". Jour souhaité : " + (j ? j.getAttribute("data-jour-rdv") : "à convenir") + ". Véhicule : " + v + ".";
    box.querySelector("[data-envoi-rdv]").href = lienWa(msg);
  }
  document.addEventListener("click", function (ev) {
    var p = ev.target.closest("[data-rdv] [data-puce]");
    if (p) { p.setAttribute("aria-pressed", p.getAttribute("aria-pressed") === "true" ? "false" : "true"); majLienRdv(p.closest("[data-rdv]")); return; }
    var j = ev.target.closest("[data-rdv] [data-jour-rdv]");
    if (j) { $$(".jour", j.parentNode).forEach(function (x) { x.setAttribute("aria-pressed", x === j ? "true" : "false"); }); majLienRdv(j.closest("[data-rdv]")); }
  });
  document.addEventListener("input", function (ev) { var b = ev.target.closest && ev.target.closest("[data-rdv]"); if (b) majLienRdv(b); });

  /* ---------- Exemples de prix : « Demander pour ma voiture » prépare la demande de devis ---------- */
  document.addEventListener("click", function (ev) {
    var a = ev.target.closest && ev.target.closest("[data-prix-demande]");
    var m = a && $("#form-devis [data-d-msg]");
    if (!m) return;
    var d = a.getAttribute("data-prix-demande");
    if (m.value.indexOf(d) < 0) m.value = d + ". Quel est le prix pour ma voiture ?" + (m.value.trim() ? "\n" + m.value : "");
    m.classList.add("rempli");
  });

  /* ---------- Barre du bas : cachée pendant qu'on tape (le clavier du téléphone la ferait remonter sur le champ) ---------- */
  var CHAMP = "input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=file]):not([type=hidden]), textarea, select";
  var estChamp = function (el) { return !!(el && el.matches && el.matches(CHAMP)); };
  document.addEventListener("focusin", function (ev) { if (estChamp(ev.target)) document.body.classList.add("saisie"); });
  document.addEventListener("focusout", function () {
    setTimeout(function () { if (!estChamp(document.activeElement)) document.body.classList.remove("saisie"); }, 150);
  });

  /* ---------- Fiche produit (téléphone) : bande « prix · Ajouter » quand le bouton d'achat n'est pas à l'écran ---------- */
  function achatColle() {
    var bande = $("[data-achat-colle]"), f = $(".formulaire-produit"), b = f && $("[type=submit]", f);
    if (!bande || !b || bande.__ok || !("IntersectionObserver" in window)) return;
    bande.__ok = true;
    var mq = window.matchMedia("(max-width: 900px)"), vu = true;
    var maj = function () { var on = mq.matches && !vu; bande.hidden = !on; document.body.classList.toggle("achat-colle-on", on); };
    new IntersectionObserver(function (e) { vu = e[e.length - 1].isIntersecting; maj(); }, { rootMargin: "0px 0px -90px 0px" }).observe(b);
    if (mq.addEventListener) mq.addEventListener("change", maj);
    $("[data-achat-colle-btn]", bande).addEventListener("click", function () { if (f.requestSubmit) f.requestSubmit(b); else b.click(); });
  }

  /* ---------- Diagnostic d'affichage (?diag=1) : où finit l'écran utile sur un téléphone ----------
     Ligne rouge = bas de la fenêtre (bottom: 0) · ligne verte = bas + zone sûre (env(safe-area-inset-bottom)) */
  function diagnostic() {
    if (!/[?&]diag=1/.test(location.search) || $("#diag-abc")) return;
    var cree = function (css) { var d = document.createElement("div"); d.style.cssText = "position:fixed;pointer-events:none;" + css; document.body.appendChild(d); return d; };
    var sb = cree("left:0;top:0;width:1px;visibility:hidden;height:env(safe-area-inset-bottom)");
    var sh = cree("left:0;top:0;width:1px;visibility:hidden;height:env(safe-area-inset-top)");
    cree("left:0;right:0;bottom:0;height:3px;background:#f00;z-index:998");
    cree("left:0;right:0;bottom:env(safe-area-inset-bottom);height:3px;background:#0c0;z-index:998");
    var box = cree("left:8px;right:8px;top:84px;z-index:999;background:#fff;color:#000;font:13px/1.4 ui-monospace,monospace;padding:10px 12px;border-radius:10px;border:2px solid #f00;white-space:pre-wrap");
    box.id = "diag-abc";
    var maj = function () {
      var b = $(".bas-nav"), r = b && b.getBoundingClientRect(), vv = window.visualViewport;
      box.textContent = [
        "fenêtre " + innerWidth + "×" + innerHeight + " · html " + document.documentElement.clientHeight,
        "visuel " + (vv ? Math.round(vv.height) + " (décalage " + Math.round(vv.offsetTop) + ")" : "-") + " · écran " + screen.width + "×" + screen.height,
        "zone sûre bas " + Math.round(sb.getBoundingClientRect().height) + " · haut " + Math.round(sh.getBoundingClientRect().height),
        "barre ABC : haut " + (r ? Math.round(r.top) : "-") + " · bas " + (r ? Math.round(r.bottom) : "-") + (document.documentElement.classList.contains("safari-flottant") ? " · réglage Safari" : ""),
        "défilement " + Math.round(scrollY) + " · plein écran " + matchMedia("(display-mode: standalone)").matches,
        (navigator.userAgent.match(/OS [\d_]+|Version\/[\d.]+|Chrome\/[\d.]+/g) || []).join(" ")
      ].join("\n");
    };
    maj(); addEventListener("resize", maj); addEventListener("scroll", maj, { passive: true });
    if (window.visualViewport) visualViewport.addEventListener("resize", maj);
  }

  function init() {
    reveler(); horaires(); galeriesVoiture(); sousRayons(); achatColle(); diagnostic();
    if (!window.__abcHoraires) window.__abcHoraires = setInterval(horaires, 60000);
    $$("[data-rdv]").forEach(function (b) { joursRdv(b); majLienRdv(b); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
